export const ARABIC_SYMBOLS: Record<string, string> = {
  AED: '\u{E1000}',
  SAR: '\u{E1001}',
};
